
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.688 19.181c6.074 0 11-4.253 11-9.5 0-5.246-4.926-9.5-11-9.5-6.075 0-11 4.254-11 9.5 0 1.947.677 3.756 1.84 5.262l-1.84 4.239 5.385-1.33a12.283 12.283 0 005.614 1.33zm-6.116-7.23a1.885 1.885 0 100-3.77 1.885 1.885 0 000 3.77zm8.162-1.885a1.885 1.885 0 11-3.77 0 1.885 1.885 0 013.77 0zm4.4 1.885a1.885 1.885 0 100-3.77 1.885 1.885 0 000 3.77z","fill":"#E7E5EC"}})])
          )
        }
      }
    